(function () {
  'use strict';

  function checkPin() {
    var input = document.getElementById('pinInput');
    var result = document.getElementById('pinResult');
    if (!input || !result) return;

    var val = input.value.trim();
    result.style.display = 'none';

    if (val.length !== 6 || isNaN(val)) {
      result.textContent = 'Enter a valid 6-digit pin code';
      result.className = 'pincode-result fail';
      result.style.display = 'inline-block';
      return;
    }

    var first2 = parseInt(val.slice(0, 2), 10);
    var metro = [40, 11, 56, 50, 60, 70, 38, 30];
    var isMetro = metro.indexOf(first2) !== -1;

    result.textContent = isMetro
      ? 'Same-day & express available'
      : 'Standard & express available';
    result.className = 'pincode-result ok';
    result.style.display = 'inline-block';
  }

  // Official manufacturer support portals only — no fabricated local addresses/phones.
  var brandSupport = {
    hp: {
      name: 'HP Support',
      url: 'https://support.hp.com/in-en',
      note: 'Use HP Support to find authorized service locations and register a claim.'
    },
    lenovo: {
      name: 'Lenovo Support',
      url: 'https://support.lenovo.com/in/en/',
      note: 'Use Lenovo Support to locate service centres and check warranty status.'
    },
    dell: {
      name: 'Dell Support',
      url: 'https://www.dell.com/support/home/en-in',
      note: 'Use Dell Support with your service tag to find warranty options and service centres.'
    },
    asus: {
      name: 'ASUS Support',
      url: 'https://www.asus.com/in/support/',
      note: 'Use ASUS Support to find service locations and raise a repair request.'
    },
    acer: {
      name: 'Acer Support',
      url: 'https://www.acer.com/in-en/support',
      note: 'Use Acer Support to find authorized service centres near you.'
    },
    lg: {
      name: 'LG Support',
      url: 'https://www.lg.com/in/support/',
      note: 'Use LG Support to find service centres and register a product issue.'
    },
    samsung: {
      name: 'Samsung Support',
      url: 'https://www.samsung.com/in/support/',
      note: 'Use Samsung Support to find service centres and check warranty coverage.'
    }
  };

  function findCentres() {
    var brandEl = document.getElementById('brand-select');
    var resultsEl = document.getElementById('results');
    var noResult = document.getElementById('no-result');
    if (!brandEl || !resultsEl || !noResult) return;

    var brand = brandEl.value;

    resultsEl.innerHTML = '';
    resultsEl.classList.remove('show');
    noResult.classList.remove('show');

    if (!brand) {
      alert('Please select a brand.');
      return;
    }

    var support = brandSupport[brand];
    if (!support) {
      noResult.classList.add('show');
      return;
    }

    resultsEl.innerHTML =
      '<div class="centre-card">' +
      '<div class="centre-info">' +
      '<h4><i class="ti ti-building" aria-hidden="true"></i> ' + support.name + '</h4>' +
      '<p><i class="ti ti-info-circle" aria-hidden="true"></i> <span>' + support.note + '</span></p>' +
      '<p><i class="ti ti-world" aria-hidden="true"></i> <span>Official manufacturer portal — Blueberry does not list third-party addresses.</span></p>' +
      '</div>' +
      '<div class="centre-actions">' +
      '<a href="' + support.url + '" target="_blank" rel="noopener noreferrer" class="centre-btn primary">Open ' + support.name + ' ↗</a>' +
      '</div>' +
      '</div>';

    resultsEl.classList.add('show');
  }

  window.checkPin = checkPin;
  window.findCentres = findCentres;

  document.addEventListener('DOMContentLoaded', function () {
    var wrapper = document.querySelector('.blueberry-page');
    if (wrapper) {
      var linkMap = {
        '/pages/contact': wrapper.dataset.bbContactUrl,
        '/pages/contact-us': wrapper.dataset.bbContactUrl,
        '/pages/help-center': wrapper.dataset.bbHelpUrl,
        '/pages/help-centre': wrapper.dataset.bbHelpUrl,
        '/pages/returns-refunds': wrapper.dataset.bbReturnsUrl,
        '/pages/return-refund': wrapper.dataset.bbReturnsUrl
      };
      Object.keys(linkMap).forEach(function (broken) {
        var fixed = linkMap[broken];
        if (!fixed) return;
        document.querySelectorAll('a[href="' + broken + '"]').forEach(function (anchor) {
          anchor.setAttribute('href', fixed);
        });
      });
    }

    var pinInput = document.getElementById('pinInput');
    if (pinInput) {
      pinInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          checkPin();
        }
      });
    }

    var contactForm = document.getElementById('BlueberryContactForm');
    if (contactForm) {
      contactForm.addEventListener('submit', function () {
        var topic = document.getElementById('ContactFormTopic');
        var body = document.getElementById('ContactFormMessage');
        if (topic && body && topic.value) {
          body.value = 'Topic: ' + topic.value + '\n\n' + body.value;
        }
      });
    }
  });
})();
